export enum TimeSeriesType {
  Day = 0,
  Hour = 1
}